'use strict';

const GroupFilterViewTemplate = require('balus/ui/template/body/user/content/group-filter.hbs');
const GroupItemViewTemplate = require('balus/ui/template/body/user/content/group-filter-item.hbs');
const NoGroupTemplate = require('balus/ui/template/body/user/content/no-group.hbs');
const Mn = require('backbone.marionette');

const GroupItemView = Mn.View.extend({
    tagName: 'li',
    className: 'group-filter-item',
    triggers: {
        'click': 'group:select'
    },
    template: GroupItemViewTemplate,
    templateContext: function() {
        return {
            imageURL: this.model.getImageURL()
        }
    }
});

const NoGroupView = Mn.View.extend({
    template: NoGroupTemplate
});

module.exports = Mn.CompositeView.extend({
    template: GroupFilterViewTemplate,
    childViewContainer: '.group-list',
    childView: GroupItemView,
    triggers: {
        'click .group-filter-all': 'filter:all'
    },
    childViewTriggers: {
        'group:select': 'group:select'
    },
    initialize: function() {
        this._filteredGroup = this.getOption('filteredGroup');
    },

    templateContext: function() {
        const group = this._filteredGroup;
        let j = null;
        if(group) {
            j = group.toJSON();
            j.imageURL = group.getImageURL();
            j.isFiltered = true;
        }

        return j;
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/user/content/group-filter.js